import { CodeUoM, InvoiceLine, PriceBook, PriceListMode } from '../../entities';

export interface PriceBookCopyRequest {
    copyId: string;
    sourceId
    priceBook: PriceBook;
}

export interface CodeUoMPriceRequest {
    _id: string;
    codeName: string;
    codeUoM: CodeUoM;

}

export interface CodesPricesRequest {
    codes: CodeUoMPriceRequest[];
    sellPriceBookId: string;
    buyPriceBookId: string;
    technicianId: string;
    type?: CodePriceRequestType; // if !type, get price for both sell and buy
    workOrderId?: string;
}

export interface LinesRequest {
    codes: InvoiceLine[];
    buyPriceBookId?: string;
    sellPriceBookId?: string;
    technicianId?: string;
}

export enum CodePriceRequestType {
    BuyPrice = 'BuyPrice',
    SellPrice = 'SellPrice'
}

export interface PricelistCopyRequest {
    sourceId: string;
    sourceMode: PriceListMode;
    newPricelist: PriceBook;
}